import { isWebView } from 'shared/constants/AppTypeConstants';
import { formatPlural } from 'shared/helpers/IntlHelpers';
import { ACHPaymentInfoDTO } from 'shared/modules/carrier-profile/data/CarrierProfileDTO';
import { BankDifferentBanner } from '../BankDifferentBanner';
import {
  SUPERPAY_PROFILE_ROUTES,
  SUPERPAY_WEBVIEW_ROUTES,
} from '../superpay/SuperPayRoute';
import { useSuperPaySettings } from '../data/SuperPayAPI';

interface ACHSuperPayBankDifferentBannerProps {
  paymentInfo: ACHPaymentInfoDTO;
}

export function ACHSuperPayBankDifferentBanner({
  paymentInfo,
}: ACHSuperPayBankDifferentBannerProps) {
  const shouldShowBanner = !!paymentInfo.is_superpay_bank_different;

  const { data: superPaySettings } = useSuperPaySettings({
    enabled: shouldShowBanner,
  });

  if (!shouldShowBanner) {
    return null;
  }

  const hoursUntilUpdateAllowed = superPaySettings?.hours_until_update_allowed;
  const isDisabled = !!hoursUntilUpdateAllowed && hoursUntilUpdateAllowed > 0;

  return (
    <BankDifferentBanner
      title="Your SuperPay bank account is different from ACH"
      description="It seems you have different bank accounts in ACH Payment Info section and SuperPay. If you want to receive SuperPay payment to the same bank account, change SuperPay too."
      buttonLabel="Change SuperPay Bank Account"
      to={
        isWebView
          ? SUPERPAY_WEBVIEW_ROUTES.changeBankAccount
          : SUPERPAY_PROFILE_ROUTES.changeBankAccount
      }
      dismissStorageKey="ach_superpay_bank_different_banner_dismissed"
      dismissTag={paymentInfo.bank_account_number}
      disabled={isDisabled}
      disabledTooltip={
        isDisabled
          ? `You have changed your email/phone in the last 24 hours. You can't change SuperPay bank account for ${hoursUntilUpdateAllowed} ${formatPlural(hoursUntilUpdateAllowed, 'hour', 'hours')}.`
          : undefined
      }
    />
  );
}
